// public/js/features/alerts/alert-notifications.js
// App-wide alert notifications: polls active events, shows a toast + a desktop
// Notification for new ones, and keeps the sidebar badge in sync. Web Push
// (phone, browser closed) is added in Step C; this covers the open-app case.
import { listAlertEvents } from './api.js';

const POLL_MS = 45000;
let _started = false;
let _seen = new Set();
let _primed = false; // first poll only primes the seen-set (no notification spam)

export async function ensureNotificationPermission(request = false) {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (request && Notification.permission === 'default') {
    try { return (await Notification.requestPermission()) === 'granted'; } catch { return false; }
  }
  return Notification.permission === 'granted';
}

function updateBadge(count) {
  for (const id of ['alerts-nav-badge', 'topbar-alert-badge']) {
    const b = document.getElementById(id);
    if (!b) continue;
    b.textContent = count > 99 ? '99+' : String(count);
    b.classList.toggle('d-none', !count);
  }
}

function notify(ev) {
  const title = `Alert: ${ev.assetLabel || ev.assetUUID}`;
  const body = `${ev.metric} = ${ev.value} (${ev.operator} ${ev.threshold})`;
  window.showToast?.(`${title} — ${body}`, ev.severity === 'critical' ? 'danger' : 'warning');
  if (('Notification' in window) && Notification.permission === 'granted') {
    try {
      const n = new Notification(title, { body, tag: ev.alertEventId, requireInteraction: ev.severity === 'critical' });
      n.onclick = () => { window.focus(); window.location.hash = '#alerts'; n.close(); };
    } catch {}
  }
}

async function poll() {
  try {
    const events = await listAlertEvents({ status: 'active', limit: 100 });
    updateBadge(events.length);
    if (!_primed) { events.forEach(e => _seen.add(e.alertEventId)); _primed = true; return; }
    for (const ev of events) {
      if (!_seen.has(ev.alertEventId)) { _seen.add(ev.alertEventId); notify(ev); }
    }
  } catch (e) {
    // silent — alerting must never disrupt the app (e.g. tables not yet created)
  }
}

export function startAlertNotifications() {
  if (_started) return;
  _started = true;
  ensureNotificationPermission(false);
  poll();
  setInterval(poll, POLL_MS);
}
